import axios from "axios";
import { BASE_URL } from "./env";
import { clearSession, getSessionToken } from "../../utility/services/session";

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 90000,
});

const blob_axios = axios.create({
  baseURL: BASE_URL,
  responseType: "blob",
  timeout: 90000,
});

const attachAuth = (config) => {
  const token = getSessionToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

instance.interceptors.request.use(attachAuth, (error) => Promise.reject(error));
blob_axios.interceptors.request.use(attachAuth, (error) => Promise.reject(error));

const handleUnauthorized = (error) => {
  const status = error?.response?.status;
  if (status === 401) {
    const url = String(error?.config?.url || "");
    const isAuthEndpoint =
      /tryLoginAdmin|loginStaff|userLoginDetail|userSignupAPI|adminSignup/i.test(
        url
      );
    if (!isAuthEndpoint && getSessionToken()) {
      clearSession();
      if (
        typeof window !== "undefined" &&
        !/login|staffLogin|user_login|clientLogin/i.test(window.location.pathname)
      ) {
        window.location.assign("/user_login");
      }
    }
  }
  return Promise.reject(error);
};

instance.interceptors.response.use((res) => res, handleUnauthorized);
blob_axios.interceptors.response.use((res) => res, handleUnauthorized);

export default { instance, blob_axios };
